import {createHashHistory} from 'history'
import {applyMiddleware, compose, createStore} from 'redux';

import {persistReducer, persistStore} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import {createEpicMiddleware} from 'redux-observable';
import thunk from 'redux-thunk';

import createRootReducer from './reducers';
import rootEpic from './epics'


const composeEnhancers =  compose;


const epicMiddleware = createEpicMiddleware();

export const history = createHashHistory();
const rootReducer = createRootReducer(history);

const persistConfig = {
    key: 'root',
    storage: storage,
    stateReconciler: autoMergeLevel2,  // see "Merge Process" section for details.
    whitelist: ['Auth', 'Notifications'],  // Things, we want to persist
};
//@ts-ignore
const persistedReducer = persistReducer(persistConfig, rootReducer);

const preloadedState = {};
export const store = createStore(
    persistedReducer,
    //@ts-ignore
    preloadedState,
    composeEnhancers(
        applyMiddleware(
            thunk,
            epicMiddleware,
             // neat middleware that logs actions
        )
    )
);

epicMiddleware.run(rootEpic);

export const persistor = persistStore(store);
